<template>
  <div class="c-feature__promo-banner-container">
    <div class="c-feature__promo-banner">
      <h2 class="c-feature__promo-banner-title text-color--blue">
        new locations coming soon:
      </h2>
      <div class="c-feature__promo-banner-title__wrapper">
        <p
          class="c-feature__promo-banner-description text-color--brown"
          v-for="(location, index) in locations"
          :key="index"
        >
          {{ location.c_locationName }} - {{ location.address.city }},
          {{ location.address.region }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['locations'],
};
</script>
